/**
 * constants.ts
 * ------------
 * Shared application-level constants.
 *
 * Keep runtime config (credentials, pool IDs, tokens) in configService.ts.
 * Keep simple, environment-independent constants here.
 */

/** Base URL for the Nestingale CMS CloudFront CDN. All JSON assets are served from here. */
export const CMS_CDN_URL = 'https://d2ffb7z1ailwvo.cloudfront.net';
